import React from "react";

function SubmitButton({
  isLoading = false,
  text = "Submit",
  loadingText = "Submitting...",
  className = "",
  disabled = false,
}) {
  return (
    <button
      type="submit"
      disabled={isLoading || disabled}
      className={`btn bg-primary text-white py-2 ${className}`}
    >
      {isLoading ? (
        <>
          <span className="spinner-border spinner-border-sm align-middle me-2"></span>
          {loadingText}
        </>
      ) : (
        text
      )}
    </button>
  );
}

export default SubmitButton;
